<template>
  <div :class="[ 'email' ]">
    <p>Sign up for updates to be alerted as soon as event details have been finalized.</p>
    <form  class="form form-inline" novalidate="" v-on:submit="subscribe">
      <div class="form-group">
        <svg width="16px" height="54px" viewBox="0 0 16 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Group-9" fill="#FFFFFF">
              <polygon id="Fill-1" points="0 5.62440022 5.62440022 5.62440022 5.62440022 0.00120000005 0 0.00120000005"></polygon>
              <polygon id="Fill-2" points="0 17.6916007 5.62440022 17.6916007 5.62440022 12.0672005 0 12.0672005"></polygon>
              <polygon id="Fill-3" points="10.2324004 17.6916007 15.8568006 17.6916007 15.8568006 12.0672005 10.2324004 12.0672005"></polygon>
              <polygon id="Fill-4" points="10.2324004 29.7588012 15.8568006 29.7588012 15.8568006 24.134401 10.2324004 24.134401"></polygon>
              <polygon id="Fill-5" points="0 29.7588012 5.62440022 29.7588012 5.62440022 24.134401 0 24.134401"></polygon>
              <polygon id="Fill-6" points="0 41.8272017 5.62440022 41.8272017 5.62440022 36.2028014 0 36.2028014"></polygon>
              <polygon id="Fill-7" points="10.2324004 41.8272017 15.8568006 41.8272017 15.8568006 36.2028014 10.2324004 36.2028014"></polygon>
              <polygon id="Fill-8" points="10.2324004 53.8956021 15.8568006 53.8956021 15.8568006 48.2712019 10.2324004 48.2712019"></polygon>
            </g>
          </g>
        </svg>
        <label for="mce-EMAIL" class="sr-only">Enter Email Address</label>
        <input type="email" name="EMAIL" id="mce-EMAIL" placeholder="Enter Email Address" class="form-control" required v-model="email" />
        <button type="submit" class="btn btn-light" name="subscribe">
          <span v-if="!isLoadingSubscribe">Subscribe</span>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-else></span>
        </button>
      </div>
    </form>
    <p v-if="error" class="error">{{ error }}</p>
  </div>
</template>

<script>
import axios from "axios"

export default {
  name: 'Email',
  data: function () {
    return {
      email: "",
      error: "",
      isLoadingSubscribe: false,
    }
  },
  methods: {
    subscribe: function(e) {
      e.preventDefault()
      this.error = ""

      if (!this.email || !/@/.test(this.email)) {
        this.error = "Please enter an email address"
      }
      else {
        this.isLoadingSubscribe = true

        axios.post('/api/subscribe', {
          email: this.email,
          referral: window.localStorage.getItem('referral') || "",
        })
          .then((response) => {
            this.$router.push(`/dashboard/${response.data.loginCode}`)
          })
          .catch((error) => {
            this.isLoadingSubscribe = false
            if (error.response) {
              this.error = error.response.data.error
            }
            else {
              this.error = "Sorry, something went wrong. Please try again later."
            }
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/variables";

div.email {
  padding-bottom: 85px;

  @media all and (max-width: $mobileMax) {
    padding-bottom: 75px;
  }

  p {
    font-size: 25px;
    text-align: center;
    font-weight: 700;
    line-height: calc(40/30);
    margin: 0 0 40px;
    color: white;

    @media all and (max-width: $mobileMax) {
      font-size: 24px;
    }
  }

  p.error {
    font-size: 14px;
    margin: 10px 0 0;
  }

  form.form {
    display: flex;

    div.form-group {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      svg {
        margin: 0 30px 0 0;

        @media all and (max-width: $mobileMax) {
          display: none;
        }
      }

      @media all and (max-width: $mobileMax) {
        flex-direction: column;
      }
    }
  }

  input.form-control {
    background-color: transparent;
    border-color: white;
    color: white;
    font-size: 14px;
    padding-left: 1em;
    height: calc(1.5em + 1rem + 2px);
    flex: 5;
    margin: 0 13px 0 0;
    border-radius: 0;

    @media all and (max-width: $mobileMax) {
      margin: 0 0 15px;
      padding-top: 0.75em;
      padding-bottom: 0.75em;
    }

    &::placeholder {
      color: white;
    }
  }

  button.btn.btn-light {
    flex: 2;
    font-size: 14px;
    height: calc(1.5em + 1rem + 2px);
    color: black;
    font-weight: 700;

    @media all and (max-width: $mobileMax) {
      flex: 5;
      padding-top: 0.5em;
      padding-bottom: 0.5em;
    }
  }
}
</style>
